export enum CARD_LAYOUT {
  DEFAULT_LAYOUT = 0,
  EXPANSION_LAYOUT = 1,
}
